import { Link } from "@tanstack/react-router";

export function Header() {
  return (
    <header className="site-header">
      <div className="container">
        <Link to="/" className="brand">
          notify<b>.</b>
        </Link>
        <nav className="nav">
          <Link to="/docs" className="navlink">
            Docs
          </Link>
          <Link to="/docs/api-reference" className="navlink">
            API
          </Link>
          <a
            href="https://github.com/mtkl6"
            className="navlink"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
        </nav>
        <Link to="/docs/quickstart" className="btn btn-coral">
          Get started
        </Link>
      </div>
    </header>
  );
}
